import React, { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, TableSortLabel, Divider } from '@mui/material';
import { Customer, CustomerFilterData } from 'models';
import { useCustomers, useTableContext } from 'hooks';
import { 
	TableErrorMessage, 
	TableLoadingBar, 
	TablePaginationFooter, 
	CustomerFilterPane,
	CustomerRow, 
	TableEmptyRow,
	CustomerForm
} from 'components';

export const CustomerTable = () => {
	const { customers, isFetching, error, filterFunction } = useCustomers();
	const {
		visibleData,
		page,
		rowsPerPage,
		order,
		orderBy,
		handlePageChange,
		handleChangeRowsPerPage,
		filterData,
		setFilterData,
		handleSort
	} = useTableContext<Customer, CustomerFilterData>({ data: customers, filterFunction })
	return (
		<>
			<CustomerFilterPane filterData={filterData} setFilterData={setFilterData} />
			<Divider />
			<TableContainer component={Paper}>
				<Table aria-label='collapsible table'>
					<TableHead>
						<TableRow>
							<TableCell />
							<TableCell>
								<TableSortLabel active={orderBy === 'email'} direction={orderBy === 'email' ? order : 'asc'} onClick={() => handleSort('email')} />
								Email
							</TableCell>
							<TableCell>
								<TableSortLabel active={orderBy === 'firstName'} direction={orderBy === 'firstName' ? order : 'asc'} onClick={() => handleSort('firstName')} />
								First name
							</TableCell>
							<TableCell>
								<TableSortLabel active={orderBy === 'lastName'} direction={orderBy === 'lastName' ? order : 'asc'} onClick={() => handleSort('lastName')} />
								Last name
							</TableCell>
							<TableCell>
								<TableSortLabel active={orderBy === 'phone'} direction={orderBy === 'phone' ? order : 'asc'} onClick={() => handleSort('phone')} />
								Phone
							</TableCell>
							<TableCell>
								<TableSortLabel active={orderBy === 'address'} direction={orderBy === 'address' ? order : 'asc'} onClick={() => handleSort('address')} />
								Address
							</TableCell>
							<TableCell>
								<TableSortLabel active={orderBy === 'zipCode'} direction={orderBy === 'zipCode' ? order : 'asc'} onClick={() => handleSort('zipCode')} />
								Zip Code
							</TableCell>
							<TableCell>
								<TableSortLabel active={orderBy === 'city'} direction={orderBy === 'city' ? order : 'asc'} onClick={() => handleSort('city')} />
								City
							</TableCell>
							<TableCell>
								<TableSortLabel active={orderBy === 'country'} direction={orderBy === 'country' ? order : 'asc'} onClick={() => handleSort('country')} />
								Country
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{isFetching && <TableLoadingBar colSpan={10} />}
						{error && <TableErrorMessage error={error} colSpan={10}></TableErrorMessage>}
						{!isFetching && visibleData && (
							<>
								<TableEmptyRow formComponent={<CustomerForm />} />
								{visibleData.map((row: Customer) => (
									<CustomerRow key={row.id} row={row} />
								))}
							</>
						)}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePaginationFooter totalRows={customers?.length ?? 0} page={page} rowsPerPage={rowsPerPage} handlePageChange={handlePageChange} handleChangeRowsPerPage={handleChangeRowsPerPage} />
		</>
	);
}
